import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../shared";
import { ActionTriggerInsertRequest } from "./ActionTriggerInsertRequest";
import { ZeroOutFMRequest } from "./ZeroOutFMRequest";
import { ZeroOutMeritRequest } from "./ZeroOutMeritRequest";
import { ZeroOutPBISRequest } from "./ZeroOutPBISRequest";

@Injectable()
export class SchoolAdminService {
	constructor(private httpclientService: HttpclientService) {}

	loadApplicationForLogList(applicationID, schoolID) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/LoadApplicationForLogList?ApplicationID=" + applicationID + "&SchoolID=" + schoolID;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadModuleList(applicationID, applicationKey) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/LoadModuleList?ApplicationID=" + applicationID + "&ApplicationKey=" + applicationKey;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadApplicationLogList(applicationID, LogDTBegin, LogDTEnd, ApplicationKey, LogMessageTypeCD, LogModuleName) {
		var postResult$ = new Subject();
		var url =
			"SchoolAdmin/LoadApplicationLogList?ApplicationID=" +
			applicationID +
			"&LogDTBegin=" +
			LogDTBegin +
			"&LogDTEnd=" +
			LogDTEnd +
			"&ApplicationKey=" +
			ApplicationKey +
			"&LogMessageTypeCD=" +
			LogMessageTypeCD +
			"&LogModuleName=" +
			LogModuleName;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ActionTriggerSelectList(applicationID, schoolID, active) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/ActionTriggerSelectList?ApplicationItemID=" + applicationID + "&SchoolID=" + schoolID + "&Active=" + active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
	ActionTriggerActionTypeGetList(applicationID) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/ActionTriggerActionTypeGetList?ApplicationItemID=" + applicationID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AttendanceStatusSelectList(applicationID, schoolID) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/AttendanceStatusSelectList?ApplicationItemID=" + applicationID + "&SchoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ClassAttendanceStatusSelectList(applicationID) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/ClassAttendanceStatusSelectList?ApplicationItemID=" + applicationID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	InfractionGetList(applicationID, schoolID) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/InfractionGetList?ApplicationItemID=" + applicationID + "&SchoolID=" + schoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PenaltyGetAll(ApplicationItemID, GroupAssign, StudentAssign, Active, DefinedByID, SchoolID, EDCRAssign) {
		var postResult$ = new Subject();
		var url =
			"SchoolAdmin/PenaltyGetAll?ApplicationItemID=" +
			ApplicationItemID +
			"&GroupAssign=" +
			GroupAssign +
			"&StudentAssign=" +
			StudentAssign +
			"&Active=" +
			Active +
			"&DefinedByID=" +
			DefinedByID +
			"&SchoolID=" +
			SchoolID +
			"&EDCRAssign=" +
			EDCRAssign;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PenaltyGetListByInfractionID(applicationID, InfractionID) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/PenaltyGetListByInfractionID?ApplicationItemID=" + applicationID + "&InfractionID=" + InfractionID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ActionTriggerResetTypeGetList(applicationID) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/ActionTriggerResetTypeGetList?ApplicationItemID=" + applicationID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AdminGetList(applicationID, schoolID, active) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/AdminGetList?ApplicationItemID=" + applicationID + "&SchoolID=" + schoolID + "&Active=" + active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MeritGetList(applicationID, schoolID, active) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/MeritGetList?ApplicationItemID=" + applicationID + "&SchoolID=" + schoolID + "&Active=" + active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ActionTriggerInsert(parms: ActionTriggerInsertRequest) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/ActionTriggerInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ActionTriggerTypeGetList(applicationID) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/ActionTriggerTypeGetList?ApplicationItemID=" + applicationID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ActionTriggerToggle(ApplicationItemID, ActionTriggerID, Active, Force) {
		var postResult$ = new Subject();
		var url =
			"SchoolAdmin/ActionTriggerToggle?ApplicationItemID=" +
			ApplicationItemID +
			"&ActionTriggerID=" +
			ActionTriggerID +
			"&Active=" +
			Active +
			"&Force=" +
			Force;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ActionTriggerRemove(ApplicationItemID, ActionTriggerID, Force) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/ActionTriggerRemove?ApplicationItemID=" + ApplicationItemID + "&ActionTriggerID=" + ActionTriggerID + "&Force=" + Force;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ActionTriggerDetailsGetList(ApplicationItemID, ActionTriggerID) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/ActionTriggerDetailsGetList?ApplicationItemID=" + ApplicationItemID + "&ActionTriggerID=" + ActionTriggerID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ActionTriggerReset(ApplicationItemID, ActionTriggerID) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/ActionTriggerReset?ApplicationItemID=" + ApplicationItemID + "&ActionTriggerID=" + ActionTriggerID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ZeroOutFinesMeals(parms: ZeroOutFMRequest) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/ZeroOutFinesMeals";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ZeroOutMerits(parms: ZeroOutMeritRequest) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/ZeroOutMerits";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ZeroOutPBIS(parms: ZeroOutPBISRequest) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/ZeroOutPBIS";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ZeroPermissionSelect(UserID) {
		var postResult$ = new Subject();
		var url = "SchoolAdmin/ZeroPermissionSelect?UserID=" + UserID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
